import React from 'react';
import { FaInstagram, FaFacebook, FaPhone, FaEnvelope } from 'react-icons/fa';
import profilePic from '../../assets/images/profilepic.jpg';

function About() {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-900 via-black to-gray-800 text-white flex flex-col md:flex-row items-center justify-center py-12 px-6 md:px-20">
      {/* Profile Picture on the Left */}
      <div className="w-full md:w-1/3 flex justify-center md:justify-start mb-8 md:mb-0">
        <img src={profilePic} alt="Azhar Rehman" className="w-96 h-96 object-cover rounded-lg shadow-xl" />
      </div>
      
      {/* Introduction on the Right */}
      <div className="w-full md:w-2/3 text-center md:text-left">
        <h2 className="text-4xl font-extrabold text-white mb-4">Azhar Rehman</h2>
        <p className="text-lg text-gray-300 leading-relaxed">
          Hi there! <br />
          <br />
          I'm <strong>Azhar Rehman</strong>, a dedicated Realtor and Civil Engineer with a passion for helping people find their dream homes. I bring deep expertise, unwavering dedication, and a personal touch to every transaction. Specializing in detailed house analysis, I guide clients through every step of buying, selling, or investing. Whether you're a first-time homebuyer or an experienced investor, I’m committed to providing exceptional service across all of Nova Scotia.
        </p>

        {/* Contact Buttons */}
        <div className="mt-6 flex flex-col md:flex-row items-center md:items-start">
          <a 
            href="https://www.instagram.com/azharrealty.ca/" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center bg-white text-gray-900 px-5 py-3 rounded-full font-semibold text-lg shadow-lg hover:bg-gray-200 transition mb-4 md:mb-0 md:mr-4"
          >
            <FaInstagram className="text-2xl mr-2 text-pink-600" /> Instagram
          </a>
          
          {/* Facebook Button */}
          <a 
            href="https://www.facebook.com/share/15rrpHLvu2/?mibextid=wwXIfr" 
            target="_blank" 
            rel="noopener noreferrer"
            className="flex items-center bg-blue-700 text-white px-5 py-3 rounded-full font-semibold text-lg shadow-lg hover:bg-blue-800 transition mb-4 md:mb-0 md:mr-4"
          >
            <FaFacebook className="text-2xl mr-2" /> Facebook
          </a>
          
          {/* Phone Number Button */}
          <a 
            href="tel:+1 (902) 329-7392" 
            className="flex items-center bg-blue-500 text-white px-5 py-3 rounded-full font-semibold text-lg shadow-lg hover:bg-green-600 transition mb-4 md:mb-0 md:mr-4"
          >
            <FaPhone className="text-2xl mr-2" /> +1 (902) 329-7392
          </a>

          {/* Email Button */}
          <a 
            href="mailto:azharrehman@remaxnova.ca" 
            className="flex items-center bg-red-500 text-white px-5 py-3 rounded-full font-semibold text-lg shadow-lg hover:bg-red-600 transition"
          >
            <FaEnvelope className="text-2xl mr-2" /> azharrehman@remaxnova.ca
          </a>
        </div>

        {/* Office Address */}
        <div className="mt-6 text-gray-300 text-lg">
          <p className="font-semibold">Office Address:</p>
          <p>397 Bedford Hwy</p>
          <p>Halifax, NS B3M 2L3, Canada</p>
        </div>
      </div>
    </div>
  );
}

export default About;
